import { Button } from "@/components/ui/button";
import { Play, Send, RotateCcw, XCircle } from "lucide-react";
import { NotificationLog, NotificationStatus } from "../types";

interface NotificationLogActionsProps {
  log: NotificationLog;
  onResend: (id: string) => void;
  onCancel?: (id: string) => void;
}

export function NotificationLogActions({
  log,
  onResend,
  onCancel,
}: NotificationLogActionsProps) {
  switch (log.status) {
    case NotificationStatus.PENDING:
      return (
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onResend(log.id)}
            className="flex items-center gap-1"
          >
            <Play className="h-4 w-4" />
            Send Now
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onCancel?.(log.id)}
            className="flex items-center gap-1"
          >
            <XCircle className="h-4 w-4" />
            Cancel
          </Button>
        </div>
      );
    case NotificationStatus.SENT:
      return (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onResend(log.id)}
          className="flex items-center gap-1"
        >
          <Send className="h-4 w-4" />
          Re-send
        </Button>
      );
    case NotificationStatus.FAILED:
      return (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onResend(log.id)}
          className="flex items-center gap-1"
        >
          <RotateCcw className="h-4 w-4" />
          Retry
        </Button>
      );
    case NotificationStatus.CANCELLED:
      return (
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onResend(log.id)}
            className="flex items-center gap-1"
          >
            <Play className="h-4 w-4" />
            Send Now
          </Button>
        </div>
      );
  }
}
